module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/more-topic-1-mobile.398a4b30.mp4";